/*
 * Neubau D · Glas-Seite: Größen-Filter im Sortiment.
 * [data-kgs-f="alle|6|9|11|13"] filtert Karten nach data-kgs-sizes; [data-kgw-quick] im Kopf filtert und springt zum Sortiment.
 * ?groesse=9 (z. B. aus dem Ratgeber) wählt die Größe beim Laden.
 */
(function () {
  var root = document.querySelector('[data-kgs]');
  if (!root) return;
  var chips = root.querySelectorAll('[data-kgs-f]');
  var empty = root.querySelector('[data-kgs-empty]');

  function apply(size) {
    var any = false;
    chips.forEach(function (c) { c.setAttribute('aria-pressed', c.dataset.kgsF === size ? 'true' : 'false'); });
    root.querySelectorAll('[data-kgs-group]').forEach(function (g) {
      var n = 0;
      g.querySelectorAll('[data-kgs-sizes]').forEach(function (card) {
        var on = size === 'alle' || (' ' + card.dataset.kgsSizes + ' ').indexOf(' ' + size + ' ') > -1;
        card.hidden = !on;
        if (on) n++;
      });
      g.hidden = n === 0;
      if (n) any = true;
    });
    if (empty) empty.hidden = any;
  }

  chips.forEach(function (c) { c.addEventListener('click', function () { apply(c.dataset.kgsF); }); });
  document.querySelectorAll('[data-kgw-quick]').forEach(function (b) {
    b.addEventListener('click', function () {
      apply(b.dataset.kgwQuick);
      root.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    });
  });

  var q = new URLSearchParams(window.location.search).get('groesse');
  if (q && root.querySelector('[data-kgs-f="' + q.replace(/[^0-9a-z]/g, '') + '"]')) apply(q.replace(/[^0-9a-z]/g, ''));
})();
